import {
  createContext,
  useReducer,
  useEffect,
  useRef,
  useContext,
} from "react";
import { PageValue, PageDisbatch } from "./page";
export const EditValue = createContext(null);
export const EditDisbatch = createContext(null);

const reducer = (state, action) => {
  return state;
};

export default function EditContext({ children }) {
  const [state, dispatch] = useReducer(reducer, {
    count: 0,
    current: 0,
    store: [],
  });
  const page = useContext(PageValue);
  const disbatch = useContext(PageDisbatch);
  const logs = useRef([]);
  const redoLogs = useRef([]);
  const count = useRef(0);
  const fromUndo = useRef(false);

  useEffect(() => {
    if (page) {
      if (logs.current[0] && logs.current[0].component === page.component) {
        if (!fromUndo.current) {
          logs.current = [
            ...logs.current.slice(-5),
            JSON.parse(JSON.stringify(page)),
          ];
        } else {
          fromUndo.current = false;
        }
      } else {
        logs.current = [JSON.parse(JSON.stringify(page))];

        count.current = 0;
      }
    }
  }, [page]);

  const undo = () => {
    if (logs.current[logs.current.length - (2 + count.current)]) {
      fromUndo.current = true;
      redoLogs.current = [
        ...redoLogs.current,
        JSON.parse(JSON.stringify(page)),
      ];
      const newPage = logs.current[logs.current.length - (2 + count.current)];
      count.current = count.current + 1;
      disbatch({ type: "set", value: newPage });
    }
  };
  const redo = () => {
    if (redoLogs.current[0]) {
      fromUndo.current = true;
      count.current = count.current - 1;
      const newPage = redoLogs.current[0];
      disbatch({ type: "set", value: newPage });
      redoLogs.current = redoLogs.current.slice(1);
    }
  };

  return (
    <EditDisbatch.Provider value={{ undo, redo }}>
      {children}
    </EditDisbatch.Provider>
  );
}
